import Breadcumbs from "../../../../../component/page-components/breadcumbs/breadcumbs";
import { BackIcon } from "../../../../../asset";
import style from "../add/AddTripPlanning.module.css";
import { Tabs } from "antd";
import PrimaryButton from "../../../../../component/button/PrimaryButton";
import TabOrder from "./tab-order/tab-order";
import TabDeliveryAssociate from "./tab-delivery-associate/tab-delivery-associate";
import { t } from "i18next";
import { convertTimestamp } from "../../../../../util/Util";
import useDetailDAIntrip from "./detail-da-intrip.hooks";
import BasicModal from "../../../../../component/modal/BasicModal";

const DetailInTripPlanning = () => {
  const {
    location,
    order,
    delivAso,
    route,
    depotLat,
    depotLong,
    isSkeletonMaps,
    directions,
    listOrderTrip,
    viewDetail,
    modalViewDetail,
    card,
    pageMap,
    isViewDetailPhoto,
    photoPath,
    handlePaginationMap,
    _backToDetail,
    viewDetailListOrder,
    closeModalView,
    onPreviewPhoto,
    onClosePreviewPhoto,
  } = useDetailDAIntrip();

  const items = [
    {
      key: 1,
      label: t("Order"),
      children: (
        <TabOrder
          order={order}
          route={route}
          directions={directions}
          depotLong={depotLong}
          depotLat={depotLat}
          skeleton={isSkeletonMaps}
          list={listOrderTrip}
          actionViewDetail={(id) => viewDetailListOrder(id)}
        />
      ),
    },
    {
      key: 2,
      label: t("Delivery Associate"),
      children: (
        <TabDeliveryAssociate
          delivAso={delivAso}
          route={route}
          directions={directions}
          depotLong={depotLong}
          depotLat={depotLat}
          skeleton={isSkeletonMaps}
          card={card}
          pageMap={pageMap}
          handlePaginationMap={handlePaginationMap}
        />
      ),
    },
  ];

  return (
    <>
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcumbs
            jmlLevel={5}
            menuLevel1={`Order`}
            menuLevel2={`Routes`}
            menuLevel3={`Trip Plan`}
            menuLevel4={`Detail ${location?.state?.data?.trip_plan_name} - ${location?.state?.data?.order}`}
            menuLevel5={`Detail ${location?.state?.dataDA?.delivery_associate_name}`}
          />
        </div>

        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[22px]">
            <img
              src={BackIcon}
              alt=""
              onClick={_backToDetail}
              className="cursor-pointer"
            />
            <h1 className="font-sans-bold text-2xl" id="title">
              {`Detail ${location?.state?.dataDA?.delivery_associate_name}`}
            </h1>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
          </div>
        </div>
      </div>
      <BasicModal
        isModalOpen={modalViewDetail}
        close={() => closeModalView()}
        data={viewDetail}
        onPreviewImg={(evt) => {
          onPreviewPhoto(evt);
        }}
        isViewDetailPhoto={isViewDetailPhoto}
        photoPath={photoPath}
        onClosePreviewPhoto={onClosePreviewPhoto}
      />
    </>
  );
};
export default DetailInTripPlanning;
